import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import LogoCaldenOil from "../images/logo_caldenOil_fullAzul.png";
import { requestJavaVersion } from "../helpers/nativeInterface";

const Footer = () => {
  const theme = useTheme();
  const [javaVersion, setJavaVersion] = useState(null);

  useEffect(() => {
    const handleJavaVersion = event => {
      setJavaVersion(event.detail);
    };

    window.addEventListener("javaVersionObtained", handleJavaVersion);
    requestJavaVersion();

    return () => {
      window.removeEventListener("javaVersionObtained", handleJavaVersion);
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        position: "fixed",
        bottom: "0px",
        left: 0,
        width: "100%",
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "3px 20px",
          backgroundColor: "#c3c3c3",
          color: "#fff",
        }}
      >
        <Typography
          component="div"
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          Powered by
          <Box sx={{ display: "inline-block", ml: 1 }}>
            <img src={LogoCaldenOil} alt="Logo Calden Oil Blanco" style={{ height: 28, verticalAlign: "middle", marginTop: -3 }} />
          </Box>
        </Typography>

        <Typography
          component="div"
          sx={{
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          V{process.env.REACT_APP_MOBILEPOS_VERSION}
          {javaVersion && ` | MPV${javaVersion}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
